import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiData, ClickDownloadButtonBiEvent } from '@wix/da-bi/pkg/events';
import SolidButton, {
  type Props as SolidButtonProps,
} from '@wix/da-ds/pkg/Buttons/SolidButton/SolidButton';
import { useIsCurrentUserDeviationAuthor } from '../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useFreeDownloadAction } from '../../../buttons/DownloadButton/hooks';

interface Props
  extends Omit<
    SolidButtonProps,
    'variant' | 'size' | 'onClick' | 'children' | 'biData'
  > {
  deviation: PapiDeviation;
}

const DownloadButton: React.FC<Props> = ({ deviation, ...rest }) => {
  const { t } = useTranslation();
  const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
  const freeDownloadAction = useFreeDownloadAction(deviation, isAuthor);

  return (
    <SolidButton
      variant="main"
      size="medium"
      onClick={freeDownloadAction.onClick}
      href={freeDownloadAction.href}
      biData={BiData<ClickDownloadButtonBiEvent>({
        evid: 350,
        ispaiddownload: 0,
        deviationid: deviation.deviationId,
        sectionname: 'action_bar',
      })}
      {...rest}
    >
      {t('actionbar.download')}
    </SolidButton>
  );
};

DownloadButton.displayName = 'DownloadButton';

export default DownloadButton;
